import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractModalComponent } from "../abstract-modal/abstract-modal.component";
import { BsModalRef } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";
import * as _ from 'lodash';
import { LANG_OPTIONS } from "../../lang.constants";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-participant-lang-modal',
  templateUrl: './participant-lang-modal.component.pug',
  styleUrls: ['./participant-lang-modal.component.scss'],
  standalone: false
})
export class ParticipantLangModalComponent extends AbstractModalComponent implements OnInit {

  @Input() participant_langs!: string[];
  @Input() model!: string;
  @ViewChild('orgForm', { static: false }) orgForm: any;
  orgDetails: any;
  showValidationError = false;
  newLang?: string;
  langOptions?: Map<string, string>;
  displayLangs: Array<any> = [];
  pulseModel = false;
  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService, public permissions: PermissionsService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    const validLangs = this.participant_langs.filter(lang => LANG_OPTIONS.has(lang));
    this.orgDetails = this.model == 'exit' ? { 'participant_langs': validLangs } : { 'pulse_participant_langs': validLangs }
    this.resetLangOptions();
  }

  resetLangOptions() {
    this.langOptions = new Map();
    for (let [key, value] of LANG_OPTIONS) {
      if (this.model == 'exit') {
        if (!_.includes(this.orgDetails['participant_langs'], key)) {
          this.langOptions.set(key, value);
        }

      }
      else {
        if (!_.includes(this.orgDetails['pulse_participant_langs'], key)) {
          this.langOptions.set(key, value);
        }
      }
    }
    if (this.langOptions && this.langOptions.size > 0) {
      this.newLang = this.langOptions.entries().next().value?.[0];
    } else {
      this.newLang = '';
    }

    this.displayLangs = [];
    if (this.model == 'exit') {
      for (let email_sms_lang of this.orgDetails['participant_langs']) {
        this.displayLangs.push({ "key": email_sms_lang, "value": LANG_OPTIONS.get(email_sms_lang) });
      }
    }
    else {
      for (let email_sms_lang of this.orgDetails['pulse_participant_langs']) {
        this.displayLangs.push({ "key": email_sms_lang, "value": LANG_OPTIONS.get(email_sms_lang) });
      }
    }

  }

  add() {
    if (this.model == 'exit') {
      if (!_.includes(this.orgDetails['participant_langs'], this.newLang)) {
        this.orgDetails['participant_langs'].push(this.newLang);
      }
    }
    else {
      if (!_.includes(this.orgDetails['pulse_participant_langs'], this.newLang)) {
        this.orgDetails['pulse_participant_langs'].push(this.newLang);
      }
    }
    this.resetLangOptions();
  }

  delete(toDelete) {
    if (this.model == 'exit') {
      _.remove(this.orgDetails['participant_langs'], domain => domain === toDelete);
    }
    else {
      _.remove(this.orgDetails['pulse_participant_langs'], domain => domain === toDelete);
    }
    this.resetLangOptions();
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.messages = [];
    this.showValidationError = true;
    if (!this.orgForm.valid || (this.orgDetails['participant_langs'] && this.orgDetails['participant_langs'].length === 0) || (this.orgDetails['pulse_participant_lang'] && this.orgDetails['pulse_participant_lang'].length === 0)) {
      return;
    }
    this.event.emit(this.orgDetails);
  }

  getForm() {
    return this.orgForm;
  }

}
